import { computable, observable } from "@chorda/core";
import { Nasa } from "../../api";
import { Carousel, Text } from "../../helpers";
const images = observable([]);
export const Apod = () => {
    return {
        templates: {
            content: Carousel({
                css: 'carousel-dark',
                current: 0,
                images$: $ => computable(() => {
                    return images.map(img => img.url);
                }),
                title: {
                    templates: {
                        author: Text({
                            text$: $ => computable(() => {
                                var _a, _b;
                                return (((_a = images[$.current]) === null || _a === void 0 ? void 0 : _a.copyright) || 'Unknown') + ' - ' + ((_b = images[$.current]) === null || _b === void 0 ? void 0 : _b.title);
                            })
                        })
                    }
                },
                as: {
                    templates: {
                        slides: {
                            styles: {
                                height: 500
                            }
                        },
                        // copyright: Text({
                        //     css: 'image-copyright',
                        // })
                    }
                }
            })
        },
        joints: {
            autoLoad: () => {
                if (images.length == 0) {
                    Nasa.api.apod.get({ count: 8, thumbs: true, hd: true }).then(data => {
                        images.$value = data;
                    });
                }
            }
        }
    };
};
